import React, { useEffect } from 'react';

import en from 'config/i18n/locales/en';

import i18n from 'i18n-react';

export interface I18nHelperProps {
  children: React.ReactNode;
  enabled: boolean;
}

export function I18nHelper({ children, enabled }: I18nHelperProps) {
  useEffect(() => {
    if (enabled) {
      i18n.setTexts({ __LANGUAGE__: 'en', ...en });
    }
  }, [enabled]);

  if (!enabled) {
    return children;
  }

  return <React.Fragment key="i18n-helper">{children}</React.Fragment>;
}
